import  baseHttp  from '@/services/baseHttp';
export default{
    async getAppData(context, payload) {
        if (context.rootState.monday.mondayInfo.mondayMetaObj.user.isViewOnly == false) {
            let response = await baseHttp.post(`getAppData/${context.rootState.monday.mondayInfo.item.id}`, payload);
        
            if (response.data && response.data.Success) {
                context.commit('setAppData', response.data);
                //context.commit('monday/setMdTicket',response.data.Data.userInfo,{ root: true })
                context.commit('monday/setMondayUser', response.data.Data.userInfo, { root: true })
                context.commit('monday/setMondayAttachments', response.data.Data.attachments, { root: true })
                context.commit('monday/setMondayLinkedItems', response.data.Data.linkedItems.map(d => d.workItemId).toString(), { root: true })
            } else {
                context.commit('setAppData', response.data);
            }
        } else {
            context.commit('setAppData', {});
        }
    }
};